/* eslint import/no-extraneous-dependencies: "off" */
import { DatePicker } from "antd";
import dayjs, { Dayjs } from "dayjs";
import { observer } from "mobx-react-lite";
import { PickerRef } from "rc-picker";
import * as React from "react";
import { ifDef } from "src/common/ifDef";

import { MdmCardFormStore } from "../MdmCardFormStore";
import { FnFocus, FormField } from "../types/MdmCardFormTypes";
import { ZCompDate } from "../types/metaComponent";
import { FieldBox } from "./FieldBox";
import { focusCtrl } from "./focusCtrl";

type PropsCardDate = {
  form: MdmCardFormStore;
  field: FormField;
  component: ZCompDate;
  focusBk: (onFocus: FnFocus) => void;
};

export const CardDate: React.FC<PropsCardDate> = observer((props) => {
  const { form, field, component, focusBk } = props;
  const { data, path } = field;
  // TODO: пока не используется специальный тип для дат
  const textValue: string = data?.type === "string" ? data.value : "";

  const setFormValue = (value: string | null) => {
    field.setData({
      type: "string",
      value: value ?? "", // <----------        ^--- У даты должен быть вариант null
      name: field.meta.name,
    });
    form.onChange(path);
  };

  const bin2str = (bin: Dayjs | null): string | null =>
    bin?.format("YYYY-MM-DD") ?? null;

  const [binValue, setBinValue] = React.useState<Dayjs | null>(null);
  React.useEffect(() => {
    const bv =
      textValue && typeof textValue === "string" ? dayjs(textValue) : null;
    setBinValue(bv);
    setFormValue(bin2str(bv));
  }, [textValue]);

  const placeholder = ifDef(component.placeholder, (p) =>
    form.evaluateText(p, field),
  );

  const iref = React.useRef<PickerRef>(null);
  React.useEffect(() => focusCtrl(iref.current, focusBk), [iref.current]);

  return (
    <FieldBox field={field} form={form}>
      <DatePicker
        ref={iref}
        style={{ width: "100%" }}
        value={binValue}
        format="DD.MM.YYYY"
        onChange={(newValue) => {
          setBinValue(newValue);
          setFormValue(bin2str(newValue));
          form.onChange(path);
        }}
        placeholder={placeholder}
      />
    </FieldBox>
  );
});
